import { TextField } from '@mui/material';
import { Field } from 'src/API';
import { FieldInput, FIELD_TYPES, StaticFileProperties } from 'src/api/process-module';

interface StaticFileFieldProps {
  field: FieldInput & Partial<Field>;
  index: number;
  handleFieldChange: (index: number, field: Partial<FieldInput & Partial<Field>>) => void;
  isSubmitting: boolean;
  isUsingExistingField: boolean;
}

export const StaticFileField = ({
  field,
  index,
  handleFieldChange,
  isSubmitting,
  isUsingExistingField,
}: StaticFileFieldProps) => {
  const properties = field.properties as StaticFileProperties;

  return (
    <>
      <TextField
        fullWidth
        label="File URL"
        value={properties?.fileUrl || ''}
        onChange={(e) =>
          handleFieldChange(index, {
            properties: {
              ...properties,
              type: FIELD_TYPES.STATIC_FILE,
              fileUrl: e.target.value,
            } as StaticFileProperties,
          })
        }
        disabled={isSubmitting || isUsingExistingField}
        helperText="Enter the URL of the static file"
      />
    </>
  );
};
